export default {
    browsingCurrency:   [],
    currencies:         []
}